export enum BillingType {
  INVOICE = 'invoice',
  PREPAID = 'prepaid',
}
